import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const auditListTodo = createAsyncThunk('auditList', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `audit_log`,
            params: {
                pageNo: data?.currentPage,
                pageSize: data?.pageSize,
                table_name: data?.table_name || '',
                record_id: data?.record_id || '',
                action: data?.action || '',
                performed_by: data?.performed_by || '',
                from_date: data?.from_date || '',
                to_date: data?.to_date || '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const auditListSlice = createSlice({
    name: 'auditList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(auditListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(auditListTodo.rejected, () => {
            // console.log('reject', action)
        })
    }
})

export default auditListSlice.reducer;
